<!--suppress ALL -->
<template>
  <div class="control">
    <input :disabled="disabled" :readonly="readonly" :value="value || null" class="input"
           ref="inputEl" v-unicode="{from: 48, to: 58}"/>
  </div>
</template>

<script lang="ts">
import {Prop, Component, Vue} from 'annotation';
import formatdate from "../../util/filter/formatdate";

@Component
export default class VueTimepicker extends Vue {
  @Prop()
  public value: any;

  @Prop({type: Boolean, default: false})
  public disabled: boolean;

  @Prop({type: Boolean, default: false})
  public readonly: boolean;

  @Prop({type: Number, default: 5})
  public interval: number;

  public mounted() {
    const $window: any = window;
    const $input: HTMLElement = this.$refs.inputEl;

    $window.$($input).timepicker({
      timeFormat: 'HH:mm', interval: this.interval, change: (time) => {
        if (!isNaN(time.getTime())) {
          this.$emit('input', formatdate(time, false, 'HH:mm'));
        }
      }
    });
  }
}
</script>

<style lang="scss">
.ui-timepicker-container {
  z-index: 100 !important;
}
</style>
